import { Link } from 'react-router-dom';
import { useState } from 'react';
import { Logout } from '../../../App';
import EDSLogo from "../user-home/eds.png";

export const SideMenuAdmin = () => {
  const [isExpanded, setIsExpanded] = useState(true);
  const logoutButton = () => {
    Logout();
    window.location.href = '/';
  };
  return (
    <nav
      className={
        isExpanded
          ? 'snn-user-home-side-menu-wrapper hide-on-mobile'
          : 'snn-user-home-side-menu-wrapper-not-expanded hide-on-mobile'
      }
    >
      <div className="snn-user-home-side-menu-logo-wrapper">
        <img src={EDSLogo}/>
      </div>
      <div className="snn-user-home-side-menu-options-wrapper">
        <div className="snn-user-home-side-menu-hide" onClick={() => setIsExpanded(!isExpanded)}>
          {isExpanded ? (
            <span className="material-symbols-outlined">chevron_left</span>
          ) : (
            <span className="material-symbols-outlined">chevron_right</span>
          )}
        </div>
        {/*<Link to="/admin">*/}
        {/*  <div className="snn-user-home-side-menu-option-wrapper">*/}
        {/*    <span className="snn-user-menu-icon material-symbols-outlined">receipt</span>*/}
        {/*    <p className="snn-user-home-main-content-small-text">Receipt sent</p>*/}
        {/*  </div>*/}
        {/*</Link>*/}
        <Link to="/admin/abstracts">
          <div className="snn-user-home-side-menu-option-wrapper">
            <span className="snn-user-menu-icon material-symbols-outlined">home</span>
            <p className="snn-user-home-main-content-small-text">Abstracts</p>
          </div>
        </Link>
        <Link to="/coordinator">
          <div className="snn-user-home-side-menu-option-wrapper">
            <span className="snn-user-menu-icon material-symbols-outlined">library_books</span>
            <p className="snn-user-home-main-content-small-text">Accept abstracts</p>
          </div>
        </Link>
        <Link to="/revisor">
          <div className="snn-user-home-side-menu-option-wrapper">
            <span className="snn-user-menu-icon material-symbols-outlined">home</span>
            <p className="snn-user-home-main-content-small-text">Revisor home</p>
          </div>
        </Link>
        {/*<Link to="/admin/scholarships">*/}
        {/*  <div className="snn-user-home-side-menu-option-wrapper">*/}
        {/*    <span className="snn-user-menu-icon material-symbols-outlined">receipt_long</span>*/}
        {/*    <p className="snn-user-home-main-content-small-text">Scholarships requests</p>*/}
        {/*  </div>*/}
        {/*</Link>*/}
        {/*<Link to="/payments">*/}
        {/*  <div className="snn-user-home-side-menu-option-wrapper">*/}
        {/*    <span className="snn-user-menu-icon material-symbols-outlined">receipt</span>*/}
        {/*    <p className="snn-user-home-main-content-small-text">Receipt submission</p>*/}
        {/*  </div>*/}
        {/*</Link>*/}
        {/*<Link to="/scholarships">*/}
        {/*<div className="snn-user-home-side-menu-option-wrapper">*/}
        {/*<span className="snn-user-menu-icon material-symbols-outlined">receipt_long</span>*/}
        {/*<p className="snn-user-home-main-content-small-text">Scholarships</p>*/}
        {/*</div>*/}
        {/*</Link>*/}
        <hr />
        <div className="snn-user-home-side-menu-option-wrapper">
          <span className="snn-user-menu-icon material-symbols-outlined">logout</span>
          <p className="snn-user-home-main-content-small-text" onClick={logoutButton}>
            Logout
          </p>
        </div>
      </div>
    </nav>
  );
};
